'use strict'

function chain(where, fn, secondFn){

    return function(){
        if (where === 'before'){
            secondFn.apply(this, arguments)
        }

        var result = fn.apply(this, arguments)

        if (where !== 'before'){
            secondFn.apply(this, arguments)
        }

        return result
    }
}

module.exports = chain


/*****************
 ** WEBPACK FOOTER
 ** ./~/functionally/src/chain.js
 ** module id = 838
 ** module chunks = 0
 **/